import isApiError from "@insite/client-framework/Common/isApiError";
import { del, get, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    DeleteCustomerLogoParameter,
    GetCustomerLogoApiResponseModel,
    GetCustomerLogoParameter,
    SaveCustomerLogoApiResponseModel,
    SaveCustomerLogoParameter,
} from "@midland-industries/Types/CustomerLogosModels";

const customerLogosServiceUrl = "/api/v1/customer-logos";

export async function deleteCustomerLogo(parameter: DeleteCustomerLogoParameter): Promise<ServiceResult<void>> {
    try {
        const noResponseExpected = await del(`${customerLogosServiceUrl}?billToId=${parameter.billToId}`);
        return {
            successful: true,
            result: noResponseExpected,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function getCurrentCustomerLogo(
    parameter: GetCustomerLogoParameter,
): Promise<ServiceResult<GetCustomerLogoApiResponseModel>> {
    try {
        const getCustomerLogoModel = await get<GetCustomerLogoApiResponseModel>(
            `${customerLogosServiceUrl}?billToId=${parameter?.billToId}`,
        );
        return {
            successful: true,
            result: getCustomerLogoModel,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function saveCustomerLogo(formData: FormData): Promise<ServiceResult<SaveCustomerLogoApiResponseModel>> {
    try {
        const result = await fetch(`${customerLogosServiceUrl}`, {
            method: "POST",
            body: formData as any,
        });
        const message = await (result.json() as Promise<SaveCustomerLogoApiResponseModel>);

        return {
            successful: true,
            result: message,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
